module.exports = __webpack_public_path__ + "static/media/splash-new.df9b0882.png";